import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  viewChild
} from '@angular/core';
import { RfqDialogMessages } from '@approot/models';

@Component({
  selector: 'app-rfq-dialog',
  templateUrl: './rfq-dialog.component.html',
  styleUrls: ['./rfq-dialog.component.scss']
})
export class RfqDialogComponent implements OnInit {
  @Input({ required: true }) public header: string;
  @Input({ required: true }) public messages: RfqDialogMessages[];
  @Input({ required: true }) public onConfirm: 'closeTab';
  @Output() public onConfirmClick = new EventEmitter();
  @Output() public onCancel = new EventEmitter();
  private rfqDialog = viewChild<ElementRef<HTMLDialogElement>>('rfqDialog');

  public ngOnInit(): void {
    this.rfqDialog().nativeElement.showModal();
  }

  public confirm(): void {
    this.onConfirmClick.emit();
  }

  public cancel(): void {
    this.onCancel.emit();
  }
}
